import 'css-chunksrc/client/scenes/documentCreation/form/name/styles.scss';export default {
  "name": "_name_g4hus_1",
  "title": "_title_g4hus_8",
  "input": "_input_g4hus_14"
};